module.exports = __webpack_public_path__ + "static/media/contact-photo-mobile.a6139d70.png";